import React, { useContext, useState } from 'react';
import AppContext from '../../context/app/appContext';

const Tags = ({ taxonomy }) => {
  const {
    getFiltredPosts,
    translations,
    baseUrl,
    params,
  } = useContext(AppContext);
  const { settings, terms } = taxonomy;

  let [selected, setSelected] = useState(params[settings.name] || []);

  const handleChange = (e) => {
    const taxonomy = escape(settings.name);
    const value = e.target.value;
    const exists = selected.includes(value);


    if(value === '') {
      setSelected([]);
      getFiltredPosts(taxonomy, []);
    } else {
      if(!exists) {
        setSelected([...selected, value]);
        getFiltredPosts(taxonomy, [...selected, value]);
      } else {
        const filteredItems = selected.filter(item => item !== value);
        setSelected(filteredItems);
        getFiltredPosts(taxonomy, filteredItems);
      }
    }

    handlePushState();
  }

  const handlePushState = () => {
    const formData = params || {};
    let formDataForUrl = {};
    let url = '';

    for (const key in formData) {
      const value = formData[key];

      if ([] === value) {
        continue;
      }

      const taxKey = key.replace('-', '_');
      formDataForUrl[taxKey] = value;
    }

    formDataForUrl = Object.entries(formDataForUrl).filter(
      ([key, value]) => value.length > 0
    );

    if (formDataForUrl.length !== 0) {
      const data = new URLSearchParams(formDataForUrl);
      url = `?${decodeURIComponent(data.toString())}`;
    } else {
      url = '';
    }
    window.history.pushState(params, document.title, `${baseUrl}${url}`);
  };


  if(!terms) {
    return null;
  }

  return (
    <div className="row js-component-archive-filter-tags component-archive-filter-tags">
      <div className="col-12">

        <label
          className={`d-inline-block filter-label js-filter-label btn btn-${!selected.length ? 'primary' : 'secondary'}`}
        >
          <span>{translations.showAll}</span>
          <input
            type="checkbox"
            className="filter-checkbox js-filter-checkbox"
            value={[]}
            name={`${escape(settings.name)}`}
            onChange={handleChange}
            defaultChecked={!selected.length}
          />
        </label>

        {terms.map((tag) => (
          <label
            key={tag.term_id}
            className={`d-inline-block filter-label js-filter-label btn btn-${selected.includes(tag.slug) ? 'primary' : 'secondary'}`}
          >
            <span>{tag.name}</span>
            <input
              type="checkbox"
              className="filter-checkbox js-filter-checkbox"
              name={`${escape(settings.name)}`}
              value={tag.slug}
              onChange={handleChange}
              checked={selected.includes(tag.slug)}
              />
          </label>
        ))}

      </div>
    </div>
  );
}
export default Tags;



// WEBPACK FOOTER //
// ./src/components/Tags/Tags.js